import PhotoSpecs from "./PhotoSpecs";

export default PhotoSpecs;
